<tf-search-header
    id="searchHeader"
    tfStickyToHeader
    [productType]="productType"
    [productSubtype]="productSubtype"
    [stickyOffset]="50">
</tf-search-header>

<ng-container
    *ngIf="searchStatus === SearchStatusEnum.doneWithResults
    || searchStatus === SearchStatusEnum.doneWithSuggestions
    || searchStatus === SearchStatusEnum.doneWithNoResultsFilters
    || searchStatus === SearchStatusEnum.loadingMore
    || searchStatus === SearchStatusEnum.searching">

    <ng-container *ngIf="searchResults">

        <tf-product-type-selector
            [keyword]="searchResults.keyword"
            selectedTab="assays"
            [keywordUsed]="searchResults.keywordUsed">
        </tf-product-type-selector>

        <tf-horizontal-line></tf-horizontal-line>

        <tf-search-filters
            [keyword]="searchResults.keyword"
            [keywordUsed]="searchResults.keywordUsed"
            [searchFilters]="searchResults.filters"
            [suggestedKeywords]="searchResults.suggestedKeywords"
            [suggestedKeywordsArray]="searchResults.suggestedKeywordsArray"
            [totalHits]="searchResults.totalHits"
            [type]="selectedTabName">

            <div *ngIf="enableNPAssaysFeature" class="show-multiplex-options-ctnr" desktopVersion>
                <div class="me-1">
                    <komodo-toggle
                        [label]="'Show multiplex options'"
                        [checked]="showMultiplexOptions"
                        (toggleChange)="onToggleChange($event)"
                    ></komodo-toggle>
                </div>
                <div class="popover-icon-ctnr"
                     [ngbPopover]="popContentMultiplexOptionsTemplate"
                     placement="top auto"
                     popoverClass="tf-ngb-popover">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M7.00012 2C9.76155 2 12.0001 4.23858 12.0001 7C12.0001 9.76142 9.76155 12 7.00012 12C4.2387 12 2.00012 9.76142 2.00012 7C2.00012 4.23858 4.2387 2 7.00012 2M7.00012 0C3.13413 0 0.00012207 3.13401 0.00012207 7C0.00012207 10.866 3.13413 14 7.00012 14C10.8661 14 14.0001 10.866 14.0001 7C14.0001 5.14348 13.2626 3.36301 11.9499 2.05025C10.6371 0.737498 8.85664 0 7.00012 0ZM6.00012 6.48V10.88H8.00012V6.48H6.00012ZM6.00012 3.24V5.24H8.00012V3.24H6.00012Z"
                              fill="#54545C"/>
                    </svg>
                </div>
            </div>
            <div *ngIf="enableNPAssaysFeature" class="show-multiplex-options-ctnr mobile-v" mobileVersion>
                <div class="me-1">
                    <komodo-toggle
                        [label]="'Show multiplex options'"
                        [checked]="showMultiplexOptions"
                        (toggleChange)="onToggleChange($event)"
                    ></komodo-toggle>
                </div>
                <div class="popover-icon-ctnr"
                     [ngbPopover]="popContentMultiplexOptionsTemplate"
                     placement="top auto"
                     popoverClass="tf-ngb-popover">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M7.00012 2C9.76155 2 12.0001 4.23858 12.0001 7C12.0001 9.76142 9.76155 12 7.00012 12C4.2387 12 2.00012 9.76142 2.00012 7C2.00012 4.23858 4.2387 2 7.00012 2M7.00012 0C3.13413 0 0.00012207 3.13401 0.00012207 7C0.00012207 10.866 3.13413 14 7.00012 14C10.8661 14 14.0001 10.866 14.0001 7C14.0001 5.14348 13.2626 3.36301 11.9499 2.05025C10.6371 0.737498 8.85664 0 7.00012 0ZM6.00012 6.48V10.88H8.00012V6.48H6.00012ZM6.00012 3.24V5.24H8.00012V3.24H6.00012Z"
                              fill="#54545C"/>
                    </svg>
                </div>
            </div>
        </tf-search-filters>

        <ng-container *ngIf= "searchStatus === SearchStatusEnum.doneWithNoResultsFilters">
            <error-filter [keyword]="keywordUsed" [productType]="productType"></error-filter>
        </ng-container>

        <ng-container *ngIf= "searchStatus !== SearchStatusEnum.doneWithNoResultsFilters">

            <tf-search-results-header id="tf-results-header-sub" tfStickyTo="#searchHeader">
            </tf-search-results-header>

            <tf-horizontal-line></tf-horizontal-line>

            <ng-container  *ngFor="let product of getProducts()" >

                <tf-search-result-row
                    [product]="product"
                    [relatedArraysCount]="relatedArraysCount[product.productID]">
                </tf-search-result-row>

                <tf-horizontal-line></tf-horizontal-line>

            </ng-container>

        </ng-container>

        <tf-search-footer *ngIf= "searchStatus !== SearchStatusEnum.doneWithNoResultsFilters"
            [totalHits]="searchResults.totalHits"
            [currentProductsLength]="getProducts().length">
        </tf-search-footer>
    </ng-container>

</ng-container>

<tf-loading-page *ngIf="searchStatus === SearchStatusEnum.searching"></tf-loading-page>

<ng-template #compareViewContainer></ng-template>

<ng-template #popContentMultiplexOptionsTemplate>
    Primer Limited assays are recommended for multiplexing.
    To learn more, visit <a>link TBD.</a>
</ng-template>
